module.exports = __webpack_public_path__ + "img/yellowOval.7f33c977.svg";